// extracted by mini-css-extract-plugin
export default {"PageMenuSuiviReglements":"PageMenuSuiviReglements_PageMenuSuiviReglements__V64zv","Bloc":"PageMenuSuiviReglements_Bloc__nzZ+R"};